import { TypedAction } from '@ngrx/store/src/models';
import { AppState, UrlPartSerializer } from '@immosky/types';

export class UrlParamsSerializer {
  constructor(private filterUrlPartSerializers: UrlPartSerializer[]) {}

  serialize(state: AppState): string {
    const searchParams = new URLSearchParams();

    for (const part of this.filterUrlPartSerializers) {
      const value = part.serialize(state);
      searchParams.set(part.key, value);
    }

    return searchParams.toString();
  }

  deserialize(searchParams: URLSearchParams): TypedAction<string>[] {
    const actions: TypedAction<string>[] = [];

    searchParams.forEach((value: string, key: string) => {
      const action = this.deserializeParameter(key, value);

      if (action) {
        actions.push(action);
      }
    });

    return actions;
  }

  private deserializeParameter(
    key: string,
    value: string
  ): TypedAction<string> | void {
    for (const part of this.filterUrlPartSerializers) {
      if (part.key === key) {
        return part.deserialize(value);
      }
    }
  }
}
